module.exports = __webpack_public_path__ + "static/media/insights_spinner.57696958.gif";